import { render } from "./LeaveApprovals.vue?vue&type=template&id=100ab85e&scoped=true"
import script from "./LeaveApprovals.vue?vue&type=script&lang=js"
export * from "./LeaveApprovals.vue?vue&type=script&lang=js"

import "./LeaveApprovals.vue?vue&type=style&index=0&id=100ab85e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100ab85e"]])

export default __exports__